import React from 'react';
import OrderBookApprovalForm from '../../../components/projectmng/obtainorder/OrderBookApprovalForm';

const OrderBookApprovalFormContainer = ({ type, apprUuid, setApprUuid }) => {
  return (
    <OrderBookApprovalForm
      type={type}
      apprUuid={apprUuid}
      setApprUuid={setApprUuid}
    />
  );
};

export default OrderBookApprovalFormContainer;
